import React, { useContext } from "react";

// reactstrap components
import { Spinner } from "reactstrap";

// core components
import { useQuery } from "react-query";
import ApiContext from "services/ApiContext";
import ShopContext from "services/ShopContext";
import "./packaging.css";
import DashBoardDisplay from "./PackReportDisplay";

const columnsForTable = [
  "TradeInID",
  "CreatedDate",
  "FullName",
  "Contact",
  "Logistic",
  "TrackingNo",
  "Status",
];

function PackTradeDB() {
  const shopID = useContext(ShopContext).selctShopID.ID;
  const Axios = useContext(ApiContext);

  const columns = [
    {
      name: "Trade ID",
      selector: (row) => row.TradeInID,
      sortable: true,
      wrap: true,
    },
    {
      name: "Date",
      selector: (row) => new Date(row.CreatedDate).toLocaleDateString("en-GB"),
      sortable: true,
      wrap: true,
    },
    {
      name: "Name",
      selector: (row) => row.FullName,
      sortable: true,
      wrap: true,
    },
    {
      name: "Contact No",
      selector: (row) => row.Contact,
      sortable: true,
      wrap: true,
    },
    {
      name: "Logistic",
      selector: (row) => row.Logistic,
      sortable: true,
      wrap: true,
    },
    {
      name: "Tracking Number",
      selector: (row) => row.TrackingNo,
      sortable: true,
      wrap: true,
    },
  ];

  const { isLoading, data, isSuccess, isError, refetch } = useQuery(
    `/shop/${shopID}/Packaging/GetAllTradeInRequest`,
    async () =>
      shopID !== "0" &&
      Axios.get(`/shop/${shopID}/GetAllTradeInRequest`, {
        params: {
          limitPerPage: 9999,
          internalStatus: "Trade In Parcel Transferred to Packaging",
        },
      }),
    { refetchOnWindowFocus: false }
  );

  if (isLoading) {
    return (
      <div className="content d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="content d-flex align-items-center justify-content-center">
        <h3>Something goes wrong, try refresh the page</h3>
      </div>
    );
  }

  return (
    <DashBoardDisplay
      refetch={refetch}
      columns={columns}
      data={data.data?.ShopTradeInRequestGetAllDtoList}
      isSuccess={isSuccess}
      isLoading={isLoading}
      columnsForTable={columnsForTable}
      filterList={[
        {
          field: "Logistic",
          label: "Logistic",
        },
        { field: "Status", label: "Status" },
      ]}
      forCategory="tradein"
      trackingNo="TrackingNo"
      rowState="Status"
      invoice="TradeInID"
      dateShow="CreatedDate"
      customerName="FullName"
    />
  );
}

export default PackTradeDB;
